import React from "react";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "./ClientsPartners.css";
import "../Pages/OurHistory.css";
import "../Pages/NewsandEvents.css";

import Card2 from "../Images/Headers/clients.jpg";
import Card1 from "../Images/Partners/berkeley.jpg";
import Card3 from "../Images/Partners/berkeley-air-logo-2.jpg";
import Card4 from "../Images/Partners/KPMG_logo.jpg";
import Card5 from "../Images/Partners/globalalliance.jpg";
import Card6 from "../Images/Partners/Technology-Consults-Limited-Logo.jpg";
import Card7 from "../Images/Partners/stanford.jpg";
import Card8 from "../Images/Partners/Serc.jpg";
import Card9 from "../Images/Partners/rebel.jpg";
import Card10 from "../Images/Partners/giz.jpg";
import Card11 from "../Images/Partners/worldbank.jpg";
import Card12 from "../Images/Partners/wwf.jpg";
import Card13 from "../Images/Partners/Envirofit International Ltd.jpg";
import Card14 from "../Images/Partners/psfu.jpg";
import Card15 from "../Images/Partners/Bank-of-Uganda.jpg";
import Card16 from "../Images/Partners/bsul.jpg";
import Card17 from "../Images/Partners/carbonclear.jpg";
import Card18 from "../Images/Partners/CCA logo.jpg";
import Card19 from "../Images/Partners/climate secure.jpg";
import Card20 from "../Images/Partners/Co2.jpg";
import Card21 from "../Images/Partners/dutchspark.jpg";
import Card22 from "../Images/Partners/ecotrust.jpg";
import Card23 from "../Images/Partners/Enabel.jpg";
import Card24 from "../Images/Partners/finnfund.jpg";
import Card25 from "../Images/Partners/ground-truth-solutions.jpg";
import Card26 from "../Images/Partners/GVEP.jpg";
import Card27 from "../Images/Partners/habitatforhumanity.jpg";
import Card28 from "../Images/Partners/HIVOS.jpg";
import Card29 from "../Images/Partners/idin.jpg";
import Card30 from "../Images/Partners/UKaid.jpg";
import Card31 from "../Images/Partners/impact-carbon.jpg";
import Card32 from "../Images/Partners/ImpactWater.jpg";
import Card33 from "../Images/Partners/kima foods.jpg";
import Card34 from "../Images/Partners/living earth uganda.jpg";
import Card35 from "../Images/Partners/loughborough-university-logo.jpg";
import Card36 from "../Images/Partners/masupa_logo.jpg";
import Card37 from "../Images/Partners/MECS.jpg";
import Card38 from "../Images/Partners/memdlogofnl.jpg";
import Card39 from "../Images/Partners/Myclimate.jpg";
import Card40 from "../Images/Partners/ren21_logo.jpg";
import Card41 from "../Images/Partners/snv.jpg";
import Card42 from "../Images/Partners/spgs.jpg";
import Card43 from "../Images/Partners/uganda-carbon-bureau.jpg";
import Card44 from "../Images/Partners/undp.jpg";
import Card45 from "../Images/Partners/unacc.jpg";
import Card46 from "../Images/Partners/usaid.jpg";
import Card47 from "../Images/Partners/UNREEEA.jpg";
import Card48 from "../Images/Partners/upe.jpg";
import Card49 from "../Images/Partners/SEI.jpg";
import Card50 from "../Images/Partners/PELUM.jpg";

/* ─── Partner data ───────────────────────────────────────── */
const PARTNERS = [
  {
    img: Card1,
    href: "https://www.berkeley.edu/",
    alt: "University of California, Berkeley",
  },
  { img: Card3, href: "https://berkeleyair.com/", alt: "Berkeley Air" },
  {
    img: Card4,
    href: "https://kpmg.com/xx/en/home/about/offices/kampala-1.html",
    alt: "KPMG",
  },
  {
    img: Card5,
    href: "https://cleancooking.org/",
    alt: "Global Alliance for Clean Cookstoves",
  },
  {
    img: Card6,
    href: "http://www.teco.co.ug/",
    alt: "Technology Consults Limited",
  },
  { img: Card7, href: "https://www.stanford.edu/", alt: "Stanford University" },
  {
    img: Card8,
    href: "https://schatzcenter.org/",
    alt: "Schatz Energy Research Center",
  },
  { img: Card9, href: "https://rebelgroup.com/en/", alt: "Rebel Group" },
  { img: Card10, href: "https://www.giz.de/en/worldwide/310.html", alt: "GIZ" },
  { img: Card11, href: "https://www.worldbank.org/en/home", alt: "World Bank" },
  { img: Card12, href: "https://www.worldwildlife.org/", alt: "WWF" },
  {
    img: Card13,
    href: "https://envirofit.org/",
    alt: "Envirofit International",
  },
  { img: Card14, href: "https://www.psfuganda.org/", alt: "PSFU" },
  { img: Card15, href: "https://www.bou.or.ug/", alt: "Bank of Uganda" },
  {
    img: Card16,
    href: "https://www.biogassolutions.co.ug/",
    alt: "Biogas Solutions Uganda",
  },
  { img: Card17, href: "https://www.carbonclear.earth/", alt: "Carbon Clear" },
  { img: Card18, href: "https://cleancooking.org/", alt: "CCA" },
  {
    img: Card19,
    href: "https://www.climate-secure.com/",
    alt: "Climate Secure",
  },
  { img: Card20, href: "https://www.co2balance.com/", alt: "CO2 Balance" },
  { img: Card21, href: "https://dutch-spark.org/", alt: "Dutch Spark" },
  { img: Card22, href: "https://ecotrust.or.ug/", alt: "Ecotrust" },
  { img: Card23, href: "https://www.enabel.be/", alt: "Enabel" },
  { img: Card24, href: "https://www.finnfund.fi/en/", alt: "Finnfund" },
  {
    img: Card25,
    href: "https://www.groundtruthsolutions.org/",
    alt: "Ground Truth Solutions",
  },
  { img: Card26, href: "https://energy4impact.org/", alt: "Energy 4 Impact" },
  {
    img: Card27,
    href: "https://habitat.ug/",
    alt: "Habitat for Humanity Uganda",
  },
  { img: Card28, href: "https://hivos.org/", alt: "HIVOS" },
  { img: Card29, href: "https://www.idin.org/", alt: "IDIN" },
  { img: Card30, href: "https://www.ukaiddirect.org/", alt: "UK Aid" },
  { img: Card31, href: "https://impactcarbon.org/", alt: "Impact Carbon" },
  { img: Card32, href: "http://www.impactwater.co/", alt: "Impact Water" },
  { img: Card33, href: "https://kiimafoods.com/", alt: "Kiima Foods" },
  {
    img: Card34,
    href: "https://livingearthuganda.com/",
    alt: "Living Earth Uganda",
  },
  {
    img: Card35,
    href: "https://www.lboro.ac.uk/",
    alt: "Loughborough University",
  },
  {
    img: Card36,
    href: "https://seed.uno/enterprise-profiles/masupa-enterprises",
    alt: "Masupa Enterprises",
  },
  { img: Card37, href: "https://mecs.org.uk/", alt: "MECS" },
  {
    img: Card38,
    href: "https://memd.go.ug/",
    alt: "Ministry of Energy and Mineral Development",
  },
  { img: Card39, href: "https://www.myclimate.org/en/", alt: "myclimate" },
  { img: Card40, href: "https://www.ren21.net/", alt: "REN21" },
  { img: Card41, href: "https://www.snv.org/", alt: "SNV" },
  { img: Card42, href: "https://spgs.mwe.go.ug/", alt: "SPGS" },
  {
    img: Card43,
    href: "http://www.ugandacarbon.org/",
    alt: "Uganda Carbon Bureau",
  },
  { img: Card44, href: "https://www.undp.org/uganda", alt: "UNDP Uganda" },
  { img: Card45, href: "https://www.unaccug.org/", alt: "UNACC" },
  { img: Card46, href: "https://www.usaid.gov/", alt: "USAID" },
  { img: Card47, href: "https://unreeea.org/", alt: "UNREEEA" },
  {
    img: Card48,
    href: "https://www.upenergygroup.com/",
    alt: "UP Energy Group",
  },
  {
    img: Card49,
    href: "https://www.sei.org/",
    alt: "Stockholm Environment Institute",
  },
  { img: Card50, href: "https://pelumuganda.org/", alt: "PELUM Uganda" },
];

/* ─── Component ──────────────────────────────────────────── */
function ClientsPartners() {
  return (
    <div className="cp-page">
      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img
            src={Card2}
            alt="CIRCODU Clients and Partners"
            width="1200"
            height="220"
            loading="eager"
            fetchpriority="high"
          />
        </div>
        <div className="ne-hero__overlay">
          <h1 className="ne-hero__title">Clients and Partners</h1>
          <Breadcrumb>
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            <Breadcrumb.Item>About Us</Breadcrumb.Item>
            <Breadcrumb.Item active>Clients and Partners</Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* Partners Section */}
      <section className="cp-section border-bottom">
        <div className="container border-top pt-3">
          <h2 style={{ color: "#008250", fontSize: "18px" }}>Our Network</h2>
          <p className="cp-count-badge">
            Working Alongside <strong>{PARTNERS.length}</strong> Organisations
            Worldwide
          </p>

          <div className="cp-grid">
            {PARTNERS.map((partner, index) => (
              <div className="cp-card" key={index}>
                <a
                  href={partner.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={partner.alt}
                >
                  <img
                    src={partner.img}
                    alt={partner.alt}
                    loading="lazy"
                    width="300"
                    height="113"
                  />
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ClientsPartners;
